import React, { useEffect, useState } from "react";
import { BACKEND_URL } from "../../services/Helper";
import "./Bookingpage.css";
import { useNavigate } from "react-router-dom";
import { toast } from 'react-toastify';
import AOS from "aos";
import "aos/dist/aos.css";

const notifyB = (msg) => toast.success(msg);

const Bookingpage = () => {
    const navigate = useNavigate();
    const [allBooking, setAllBooking] = useState([]);
    const [loading, setLoading] = useState(true);

    const fetchUserBooking = async () => {
        try {
            const token = localStorage.getItem("nearbeusertoken");
            const res = await fetch(`${BACKEND_URL}/nearbe/bookings`, {
                method: "GET",
                headers: {
                    Authorization: token,
                },
            });

            if (!res.ok) throw new Error("Failed to fetch booking");

            const data = await res.json();
            setAllBooking(data.getbooking);
        } catch (error) {
            console.error(error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchUserBooking();
    }, []);

    const handleLogout = () => {
        localStorage.removeItem("nearbeusertoken");
        navigate("/userlogin")
        notifyB("Logout Successfully")
    };

    useEffect(() => {
        AOS.init({ duration: 1200 });
    }, []);

    return (
        <div className="booking-container" data-aos="fade-up">
            {/* Fixed Logout button */}
            <div className="logout">
                <button onClick={handleLogout}>
                    Logout
                </button>
            </div>
            {/* Loading state */}
            {loading ? (
                <div className="no-offer-msg">⏳ Fetching your bookings...</div>
            ) : allBooking.length === 0 ? (
                <div className="no-offer-msg">🚫 No booking done by you till now.</div>
            ) : (
                <div className="booking-list">
                    {allBooking.map((booking, index) => (
                        <div className="booking-card" key={index}>
                            <h2 className="hotel-name">{booking.hotelName}</h2>
                            <div className="booking-info">
                                <p>
                                    <strong>Booking Date:</strong>{" "}
                                    {new Date(booking.createdAt).toLocaleDateString()}
                                </p>
                                <p><strong>Booked For:</strong> {new Date(booking.date).toLocaleDateString()} at {booking.time}</p>
                            </div>
                            <div className="items-section">
                                {booking.selectedItems.map((item, i) => {
                                    // Calculate the offer price if there is a discount
                                    const hasOffer = item?.offerPercentage && item.offerPercentage > 0;
                                    const offerPrice = hasOffer
                                        ? Math.round(item.itemPrice - (item.itemPrice * item.offerPercentage) / 100)
                                        : item.itemPrice;

                                    return (
                                        <div className="item-card" key={i}>
                                            <img
                                                src={item.itemImage}
                                                alt={item.itemName}
                                                className="item-image"
                                            />
                                            <div className="item-details">
                                                <h3 className="item-name">
                                                    {item.itemName}
                                                    {hasOffer && (
                                                        <span className="offerper bookingoff">
                                                            {item.offerPercentage}% OFF
                                                        </span>
                                                    )}
                                                </h3>

                                                {/* If there is an offer, show both original & discounted prices */}
                                                {hasOffer ? (
                                                    <p className="item-price">
                                                        <span className="original-price">₹{item.itemPrice}</span>{" "}
                                                        <span className="discounted-price">₹{offerPrice}</span> × {item.quantity}
                                                    </p>
                                                ) : (
                                                    <p className="item-price">₹{item.itemPrice} × {item.quantity}</p>
                                                )}
                                            </div>
                                        </div>
                                    );
                                })}
                            </div>
                            <p className="total-price">Total Price: ₹{booking.totalPrice}</p>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};

export default Bookingpage;
